import { Navigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useRole } from "../../context/RoleContext";
import api from "../../api/axios";

const ProtectedRoute = ({ element, path }) => {
  const roleId = localStorage.getItem("employee_role");
  const [userRole, setUserRole] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const { rolesConfig } = useRole();

  useEffect(() => {
    if (roleId) {
      api
        .get(`employeeRole/${roleId}`)
        .then((res) => setUserRole(res?.data[0].role_name))
        .catch((err) => console.log("Employee role error : ", err))
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [roleId]);

  if (isLoading) {
    return null;
  } else if (rolesConfig[userRole]?.pages[path]) {
    return element;
  } else {
    return <Navigate to="/error-403" />;
  }
};

export default ProtectedRoute;
